export type PlutoWritingPreferences = {
  instructions: string;
  version: number;
  updatedAt: string | null;
};

export const plutoWritingPreferencesQueryKey = (clientId: string | null, userId: string | null) =>
  ["pluto", "writing-preferences", clientId, userId] as const;
